export default {"src":"/_next/static/media/ethos-logo-black.cdc61331.svg","height":16,"width":87,"blurWidth":0,"blurHeight":0};